import { Card } from 'antd';
import clsx from 'clsx';
import React from 'react';
import { DESELECT_MESSAGE } from '../../../../../common/constants';
import CommonTooltip from '../../../../../components/CommonTooltip';
import StageListTable from './StageListTable';

const StageList = ({
  stageId,
  setStageId,
  setModalVisible,
  eqcTypeData,
  setTitle,
  setStageData,
  setRefetchStageData,
  setIsStageSelectionActive,
  isStageItemSelectionActive,
}) => {
  return (
    <Card id="stage-list-card" className="stage-list-card">
      <div
        id="stage-list-header"
        className="header d-flex align-center justify-between mb-10"
      >
        <div className="d-flex align-center">
          <h2 id="stage-list-title" className="mb-0">
            Stages
          </h2>
        </div>
        <div
          id="stage-list-header-buttons"
          className="eqc-stage-header-buttons global-checklist-stage d-flex"
        >
          <div id="eqc-details-btn" className="d-flex" />
          <div id="add-btn" />
        </div>
      </div>
      <div id="stage-selection-bar" className="mb-10" />
      <div
        className={clsx(isStageItemSelectionActive && 'stage-list-disabled')}
      >
        {isStageItemSelectionActive && (
          <CommonTooltip title={DESELECT_MESSAGE}>
            <div className="disabled-overlay" />
          </CommonTooltip>
        )}
        <StageListTable
          setStageId={setStageId}
          stageId={stageId}
          setModalVisible={setModalVisible}
          eqcTypeData={eqcTypeData}
          setModalTitle={setTitle}
          setStageData={setStageData}
          setRefetchStageData={setRefetchStageData}
          setIsStageSelectionActive={setIsStageSelectionActive}
          isStageItemSelectionActive={isStageItemSelectionActive}
        />
      </div>
    </Card>
  );
};

export default StageList;
